import { Component } from '@angular/core';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[customized-toast]',
  styleUrls: ['./toast-notification.component.scss'],
  templateUrl: './toast-notification.component.html',
  preserveWhitespaces: false,
  standalone: false
})

export class ToastNotificationComponent extends Toast {
  public constructor(
    protected override toastrService: ToastrService,
    public override toastPackage: ToastPackage,
  ) {
    super(toastrService, toastPackage);
  }
}
